import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button } from '@ipc/ipc-components';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import OperatorImpcSelectionContainer from './OperatorImpcSelectionContainer';
import {
  getLeftCheckedMailProcessingCenters,
  getRightCheckedMailProcessingCenters,
} from '../../../user/redux/selectors/UserDataSelectors';
import {
  onLeftMailProcessingCenterChecked,
  onRightMailProcessingCenterChecked,
} from '../redux/actions/OperatorImpcActions';

class OperatorImpcSelectionCriteriaContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: props.open,
    };
  }

  togglePanel = () => {
    this.setState((prevState) => ({ open: !prevState.open }));
  };

  isApplyEnabled = () => {
    if (this.props.leftCheckedMailProcessingCenters.length === 0) {
      return false;
    }
    if (this.props.rightTree) {
      if (this.props.rightCheckedMailProcessingCenters.length === 0) {
        return false;
      }
    }
    return true;
  }

  apply = () => {
    this.props.onApply();
    this.togglePanel();
  }

  render() {
    return (
      <div className="selection-criteria-container">
        <h3 className="title-div">{this.props.title}</h3>
        <div className="operator-selector-wrapper">
          <div className="operators">
            <div className="operators-selection-panel">
              <div className="operator">
                <div className="expand-div-button">
                  <h6>
                    SELECTION CRITERIA
                  </h6>
                  <div onClick={(e) => this.togglePanel(e)} className="expand-button">
                    <FontAwesomeIcon icon={this.state.open ? 'angle-down' : 'angle-right'} className="expand-icon" />
                  </div>
                </div>
                <div className={`checkboxtree-div ${this.state.open}`}>
                  <div>
                    <OperatorImpcSelectionContainer
                      {...this.props}
                    />
                  </div>
                  <div>
                    <Button
                      disabled={!this.isApplyEnabled()}
                      className={`apply-div-${!this.isApplyEnabled()}`}
                      onClick={this.apply}
                    >
                      APPLY
                    </Button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    leftCheckedMailProcessingCenters: getLeftCheckedMailProcessingCenters(state),
    rightCheckedMailProcessingCenters: getRightCheckedMailProcessingCenters(state),
  };
}

const mapDispatchToProps = (dispatch) => bindActionCreators({
  onLeftMailProcessingCenterChecked,
  onRightMailProcessingCenterChecked,
}, dispatch);

OperatorImpcSelectionCriteriaContainer.propTypes = {
  title: PropTypes.string,
  open: PropTypes.bool,
  leftCheckedMailProcessingCenters: PropTypes.arrayOf(PropTypes.string),
  rightCheckedMailProcessingCenters: PropTypes.arrayOf(PropTypes.string),
  rightTree: PropTypes.shape(PropTypes.object),
  onApply: PropTypes.func,
};

OperatorImpcSelectionCriteriaContainer.defaultProps = {
  open: false,
};

export default connect(mapStateToProps, mapDispatchToProps)(OperatorImpcSelectionCriteriaContainer);
